var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "agent-data", attrs: { fluid: "", id: "businessPerso" } },
    [
      _c(
        "v-form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            }
          }
        },
        [
          _c("v-layout", { attrs: { row: "", "justify-center": "" } }, [
            _c("h1", [_vm._v("Datos del Agente")])
          ]),
          _c(
            "v-layout",
            { staticClass: "mt-3", attrs: { "justify-center": "" } },
            [
              _c(
                "div",
                { staticClass: "agent-data__content mt-1" },
                [
                  _c(
                    "v-flex",
                    { staticClass: "pt-3 width-perso" },
                    [
                      _c("v-text-field", {
                        staticClass: "style-stepped mt-4",
                        attrs: {
                          label: "Código de agencia Matriz",
                          type: "text",
                          disabled: _vm.sending,
                          name: "codigoAgenciaMatriz"
                        },
                        model: {
                          value: _vm.codigoAgenciaMatriz,
                          callback: function($$v) {
                            _vm.codigoAgenciaMatriz =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "codigoAgenciaMatriz"
                        }
                      }),
                      _c("v-text-field", {
                        staticClass: "style-stepped mt-4",
                        attrs: {
                          label: "Oficina Matriz",
                          type: "text",
                          disabled: _vm.sending,
                          name: "oficinaMatriz"
                        },
                        model: {
                          value: _vm.oficinaMatriz,
                          callback: function($$v) {
                            _vm.oficinaMatriz =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "oficinaMatriz"
                        }
                      }),
                      _c("v-text-field", {
                        staticClass: "style-stepped mt-4",
                        attrs: {
                          label: "Tipo de Oficina Matriz",
                          type: "text",
                          disabled: _vm.sending,
                          name: "tipoOficinaMatriz"
                        },
                        model: {
                          value: _vm.tipoOficinaMatriz,
                          callback: function($$v) {
                            _vm.tipoOficinaMatriz =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "tipoOficinaMatriz"
                        }
                      }),
                      _c("v-text-field", {
                        staticClass: "style-stepped mt-4",
                        attrs: {
                          label: "Ubigeo Oficina Matriz",
                          type: "text",
                          disabled: _vm.sending,
                          name: "ubigeoOficinaMatriz"
                        },
                        model: {
                          value: _vm.ubigeoOficinaMatriz,
                          callback: function($$v) {
                            _vm.ubigeoOficinaMatriz =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "ubigeoOficinaMatriz"
                        }
                      }),
                      _c("v-text-field", {
                        staticClass: "style-stepped mt-4",
                        attrs: {
                          label: "Código Macro Región",
                          type: "text",
                          disabled: _vm.sending,
                          name: "codigoMacroRegion"
                        },
                        model: {
                          value: _vm.codigoMacroRegion,
                          callback: function($$v) {
                            _vm.codigoMacroRegion =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "codigoMacroRegion"
                        }
                      }),
                      _c("v-text-field", {
                        staticClass: "style-stepped mt-4",
                        attrs: {
                          label: "Macroregión",
                          type: "text",
                          disabled: _vm.sending,
                          name: "macroRegion"
                        },
                        model: {
                          value: _vm.macroRegion,
                          callback: function($$v) {
                            _vm.macroRegion =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "macroRegion"
                        }
                      }),
                      _c("v-text-field", {
                        staticClass: "style-stepped mt-4",
                        attrs: {
                          label: "Área",
                          type: "text",
                          disabled: _vm.sending,
                          name: "area"
                        },
                        model: {
                          value: _vm.area,
                          callback: function($$v) {
                            _vm.area =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "area"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "v-layout",
            {
              staticClass: "mt-2 width-perso",
              attrs: { "justify-center": "" }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "primary-button afilliation__btn",
                  attrs: {
                    small: "",
                    disabled: _vm.sending || _vm.$v.$invalid,
                    type: "submit"
                  }
                },
                [_vm._v("Continuar")]
              )
            ],
            1
          ),
          _c(
            "v-layout",
            {
              staticClass: "hidden-sm-and-down width-perso",
              attrs: { "justify-center": "" }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "primary-button text black capitalize",
                  attrs: { small: "" },
                  on: {
                    click: function($event) {
                      _vm.changeStep(false)
                    }
                  }
                },
                [_vm._v("Atrás")]
              )
            ],
            1
          ),
          _c("loader", {
            ref: "loaderModal",
            attrs: { text: "Realizando validación" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c167580", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c167580","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/agent-data.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1c167580","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/agent-data.vue
// module chunks = 0 1 2 3